import * as HERBUI from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

const LoginHeaderNavBar = () => {

    const history = useHistory();

    function gos() {
        history.push("/gos");
    }
    function newAlerts() {
        history.push("/budgetRelatedPdfDetails");
    }
    // function usermanuals() {
    //     history.push("/usermanuals")
    // }
    function knowYourChallan() {
        history.push('/knowYourCfmsId')
    }
    const apfrsMobileApp = () => {
        history.push("/mobileApp")
    }
    const nidhiUserManualsApp = () => {
        history.push("/nidhiUserManuals")
    }

    return (
        <>
            <HERBUI.Navbar collapseOnSelect expand="lg" className="HERB-Top-Nav" variant="dark">
                <HERBUI.Container fluid>
                    <HERBUI.Navbar.Brand href="/login">
                        <img
                            src="img/herb.svg"
                            width="250"
                            height="45"
                            className="d-inline-block align-top"
                            alt="NIDHI"
                        />
                    </HERBUI.Navbar.Brand>
                    <HERBUI.Navbar.Toggle className="bg-secondary" aria-controls="responsive-navbar-nav" style={{ marginRight: '30px' }} />
                    <HERBUI.Navbar.Collapse id="responsive-navbar-nav">
                        <HERBUI.Nav className="me-auto"></HERBUI.Nav>
                        <HERBUI.Nav>
                            <HERBUI.Nav.Link onClick={() => knowYourChallan()} className="nav_link1">
                                <b  >Know Your CFMS ID</b>
                            </HERBUI.Nav.Link>&nbsp;&nbsp;&nbsp;&nbsp;
                            <HERBUI.Nav.Link onClick={() => gos()} className="nav_link1">
                                <b  >GOs, Circulars, Memos</b>
                            </HERBUI.Nav.Link>
                            <HERBUI.Nav.Link onClick={() => newAlerts()} className="nav_link1">
                                <b>Budget 2026-27<img src="../img/gif_new.gif" alt="new" /></b>
                            </HERBUI.Nav.Link>
                            <HERBUI.NavDropdown
                                title={<b>Mobile Apps</b>}
                                id="mobile-apps-dropdown"
                                className="nav_link1"
                            >
                                <HERBUI.NavDropdown.Item
                                    href="https://appstore.nidhi.apcfss.in/iOSHerb.html"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Download Employee Mobile APP
                                </HERBUI.NavDropdown.Item>
                                <HERBUI.NavDropdown.Divider />
                                <HERBUI.NavDropdown.Item
                                    onClick={() => apfrsMobileApp()} >
                                    APFRS Mobile APP
                                </HERBUI.NavDropdown.Item>
                            </HERBUI.NavDropdown>

                            <HERBUI.Nav.Link
                                className="nav_link1"
                                onClick={() => nidhiUserManualsApp()}
                            >
                                <b>NIDHI User Manuals</b>
                            </HERBUI.Nav.Link>
                        </HERBUI.Nav>
                    </HERBUI.Navbar.Collapse>
                </HERBUI.Container>
            </HERBUI.Navbar>
        </>
    )
}
export default LoginHeaderNavBar;